import { Artwork } from "../../../data/artworks";

type ArtworkOverviewProps = {
  selectedArtwork: Artwork;
};

export const ArtworkOverview = ({ selectedArtwork }: ArtworkOverviewProps) => {
  
  const formatLink = (url: string) => {
    return url.replace(/^https?:\/\//, "");
  };

  return (
    <div className="flex flex-col gap-5 pb-20 px-0 pr-5">
      <p className="font-inter-light leading-[22px]">
        <span className="font-inter-bold">Location: </span>
        {selectedArtwork.location}{" "}
      </p>
      <p className="font-inter-light leading-[22px]">
        <span className="font-inter-bold">Sound: </span>
        {selectedArtwork.sound}{" "}
      </p>
      <p className="font-inter-light leading-[22px]">
        <span className="font-inter-bold">Artist Name: </span>
        {selectedArtwork.artistName}{" "}
      </p>
      {selectedArtwork.artistNames && (
        <p className="font-inter-light leading-[22px]">
          <span className="font-inter-bold">Artist Names: </span>
          {selectedArtwork.artistNames}{" "}
        </p>
      )}
      {selectedArtwork.danceTitle && <p className="font-inter-light leading-[22px]">
        <span className="font-inter-bold">Dance Title: </span>
        {selectedArtwork.danceTitle}{" "}
      </p>}
      {selectedArtwork.choreo && (
        <p className="font-inter-light leading-[22px]">
          <span className="font-inter-bold">Choreography by: </span>
          {selectedArtwork.choreo}{" "}
        </p>
      )}
      {selectedArtwork.musicians && (
        <p className="font-inter-light leading-[22px]">
          <span className="font-inter-bold">Musicians: </span>
          {selectedArtwork.musicians}{" "}
        </p>
      )}
      {selectedArtwork.musicComposed && (
        <p className="font-inter-light leading-[22px]">
          <span className="font-inter-bold">
            Music Composed & Performed by:{" "}
          </span>
          {selectedArtwork.musicComposed}{" "}
        </p>
      )}
      {selectedArtwork.producer && (
        <p className="font-inter-light leading-[22px]">
          <span className="font-inter-bold">Produced by: </span>
          {selectedArtwork.producer}{" "}
        </p>
      )}
      {selectedArtwork.music && (
        <p className="font-inter-light leading-[22px]">
          <span className="font-inter-bold">Music by: </span>
          <span
            className="font-inter-light"
            dangerouslySetInnerHTML={{ __html: selectedArtwork.music }}
          ></span>
        </p>
      )}
      {selectedArtwork.date && (
        <p className="font-inter-light leading-[22px]">
          <span className="font-inter-bold">Date: </span>
          {selectedArtwork.date}{" "}
        </p>
      )}
      <p className="font-inter-light leading-[22px]">
        <span className="font-inter-bold">Summary: </span>
        {selectedArtwork.summary}{" "}
      </p>
      <a
        href={selectedArtwork.link}
        target="_blank"
        className="text-lc-neon-green underline font-inter-light leading-[22px]"
      >
        {formatLink(selectedArtwork.link)}{" "}
      </a>
    </div>
  );
};
